import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";
import {
    personal_information,
    updatePersonalInfo,
    returnHome,
  } from "../../../Redux/ActionCreator";
  import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from 'react-toastify';


const EditInterests = ({ handleClick }) => {
    const dispatch = useDispatch();
  const [jobTitle1, setJobtitle1] = useState('');
  const [jobTitle2, setJobtitle2] = useState('');
  const [jobTitle3, setJobtitle3] = useState('');

  const info = useSelector((info) => info.personal_info);
  const p_profile = useSelector((e) => e.profile);
  const flowLanguage = useSelector(e => e.t_lang.selected);

  useEffect(() => {
    if (info.message !== null) {
      // get the first and lastname only
      setJobtitle1(info.message?.JobInterests !== undefined ? info.message?.JobInterests[0] : "");
      setJobtitle2(info.message?.JobInterests !== undefined ? info.message?.JobInterests[1] : "");
      setJobtitle3(info.message?.JobInterests !== undefined ? info.message?.JobInterests[2] : "");
    } else {
      let cacheInfo = getOneFromServerCache("personalInfo")
      cacheInfo.then(res => res.json())
        .then(res => {
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(personal_information(resObj));
              setJobtitle1(resObj?.JobInterests !== undefined && resObj?.JobInterests?.length > 0 ? resObj?.JobInterests[0] : "");
              setJobtitle2(resObj?.JobInterests !== undefined && resObj?.JobInterests?.length > 1 ? resObj?.JobInterests[1] : "");
              setJobtitle3(resObj?.JobInterests !== undefined && resObj?.JobInterests?.length > 2 ? resObj?.JobInterests[2] : "");
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    }
  }, []);

  const handleSaveCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (jobTitle1 !== "") {
        let personalInformation = { ...info.message, JobInterests: [jobTitle1, jobTitle2 || "", jobTitle3 || ""]}
        dispatch(personal_information(personalInformation));
        // save into server cache
        await saveIntoServerCache("personalInfo", personalInformation);
        // now create the basic profile here.
        if (p_profile.message !== null) {
          dispatch(updatePersonalInfo(personalInformation));
        }
        handleClick();
      } else {
        if (jobTitle1 == "") {
            setTimeout(() => {
                toast.error("Job title 1 is required", {
                  position: toast.POSITION.TOP_RIGHT,
                });
            }, 50);
        }
      }
    } catch (error) {
        throw error
    }
  }

    const[ showJobTitle1Placeholder, setShowJobTitle1Placeholder ] = useState(true);
    const[ showJobTitle2Placeholder, setShowJobTitle2Placeholder ] = useState(true);
    const[ showJobTitle3Placeholder, setShowJobTitle3Placeholder ] = useState(true);


  return (
    <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 md:w-[70vw] vsm:w-[90vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
        <div className="sm:max-w-[50vw] vsm:w-[90vw] gap-y-2 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg p-6 md:p-8 h-full">
            <h2 className="text-xl font-semibold text-[#5843BD] mb-4 text-center">Edit your job interests.</h2>
            
            <div className="lg:w-full w-full flex-col lg:flex-row md:gap-8 my-2">
                <div className="flex w-full vsm:my-6 md:my-4 vsm:justify-center lg:justify-start">
                    <div className="w-full flex vsm:justify-center md:justify-start">
                        <div className="w-full">
                            <label htmlFor="jobTitle1" className="text-black font-medium text-sm mb-2">
                              Job title 1
                            </label>
                            <input
                            type="text"
                            id="jobTitle1"
                            className="w-full border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                            value={jobTitle1}
                            onChange={(e) => setJobtitle1(capitalizeWords(e.target.value))}
                            placeholder={showJobTitle1Placeholder == false ? "" : "E.g plumber"}
                            onFocus={() => setShowJobTitle1Placeholder(false)}
                            onBlur={() => setShowJobTitle1Placeholder(true)}
                            />
                        </div>
                    </div>
                </div>

                <div className="flex w-full vsm:my-6 md:my-4 vsm:justify-center lg:justify-end">
                    <div className="w-full flex vsm:justify-center">
                        <div className="w-full">
                            <label htmlFor="jobTitle2" className="text-black font-medium text-sm mb-2">
                              Job title 2
                            </label>
                            <input
                            type="text"
                            id="jobTitle2"
                            className="w-full border-2 rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                            value={jobTitle2}
                            onChange={(e) => setJobtitle2(capitalizeWords(e.target.value))}
                            placeholder={showJobTitle2Placeholder == false ? "" : "E.g Carpenter"}
                            onFocus={() => setShowJobTitle2Placeholder(false)}
                            onBlur={() => setShowJobTitle2Placeholder(true)}
                            />
                        </div>
                    </div>
                </div>

                <div className="flex w-full vsm:my-6 md:my-4 vsm:justify-center lg:justify-end">
                    <div className="w-full flex vsm:justify-center">
                        <div className="w-full">
                            <label htmlFor="jobTitle3" className="text-black font-medium text-sm mb-2">
                              Job title 3
                            </label>
                            <input
                            type="text"
                            id="jobTitle3"
                            className="w-full border-2 rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                            value={jobTitle3}
                            onChange={(e) => setJobtitle3(capitalizeWords(e.target.value))}
                            placeholder={showJobTitle3Placeholder == false ? "" : "E.g Cleaner"}
                            onFocus={() => setShowJobTitle3Placeholder(false)}
                            onBlur={() => setShowJobTitle3Placeholder(true)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
                <div className="flex justify-between lg:max-w-[90vw] w-full">
                    <button
                        onClick={handleClick}
                        className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
                    >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "Cancelar"
                      ) : (
                        "CANCEL"
                      )}
                    </span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="24" height="24" rx="12" fill="#FF6633"/>
                            <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white"/>
                        </svg>

                    </button>
                    <button
                        onClick={handleSaveCall}
                        className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                    >
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "GUARDAR"
                        ) : (
                          "SAVE"
                        )}
                      </span>
                        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                </div>
            </div>
        
        </div>
        <ToastContainer />
    </div>
  );
};

export default EditInterests;
